import { eventBus as rawBus } from "./eventBus";
import type { EventName, EventPayload } from "./eventTypes";

export const eventBus = {
  on<T extends EventName>(event: T, handler: (payload: EventPayload<T>) => void) {
    rawBus.on(event, handler);
  },
  off<T extends EventName>(event: T, handler?: (payload: EventPayload<T>) => void) {
    rawBus.off(event, handler);
  },
  emit<T extends EventName>(event: T, payload?: EventPayload<T>) {
    rawBus.emit(event, payload);
  },
};

export * from "./eventTypes";
